import MultipleSelectCheckmarks from './MultipleSelectCheckmarks';
import { useState, useEffect } from 'react';
import { Spinner } from "react-bootstrap";

function WLoptions({
    sportcode,
    onOppChange,
    onSeasonChange,
    defaultOpps,
    defaultSeasons,
    teamid,
    onLocationChange,
    location
    }) {
    
    const currentYear = new Date().getFullYear()

    const [loading, setLoading] = useState(false);
    const [oppTeamOptions, setOppTeamOptions] = useState([]);
    const [seasons, setSeasons] = useState([currentYear.toString()]);

    const [homeAway, setHomeAway] = useState(location);

    const formCheckStyle = {
        width: "1em",
        height: "1em"
    }

    const homeAwayArr = ["Home", "Away", "All"]

    const seasonsOptions = [];
    
    seasonsOptions.push({ value: (currentYear).toString(), text: (currentYear).toString() });
    seasonsOptions.push({ value: (currentYear - 1).toString(), text: (currentYear - 1).toString() });

    const handleSeasonChange = (e, seasons) => {
        setSeasons(seasons);
        onSeasonChange(e, seasons);
    }

    const handleLocationChange = (e, loc) => {
        setHomeAway(loc)
        onLocationChange(loc)
    }

    useEffect(() => {
        async function fetchData() {

            const resp2 = await fetch(`/${sportcode}/OppTeams`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    TeamId: teamid,
                    SeasonIds: seasons
                })

            });
            const result2 = await resp2.json();

            if (result2) {

                setOppTeamOptions(result2.map((team => { return { value: team.id, text: team.market + ' ' + team.name } })));

            }

            setLoading(false);
        }

        fetchData();
    }, [sportcode, teamid, seasons]);

    const isChecked = (value) => homeAway === value;

    return (

        <div className="my-auto">
            {loading ? (
                <Spinner className="mx-auto d-block">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>) : (
                <>

                        <MultipleSelectCheckmarks
                            items={oppTeamOptions}
                            labelId="oppslabel"
                            labelText="Versus Opponent"
                            selectId="selectopps"
                            onChange={onOppChange}
                            defaultValues={defaultOpps}
                            >
                            
                        </MultipleSelectCheckmarks>

                        <MultipleSelectCheckmarks
                            items={seasonsOptions}
                            labelId="seasonslabel"
                            labelText={`Season (Regular Season + Playoffs)`}
                            selectId="selectseason"
                            onChange={handleSeasonChange}
                            defaultValues={defaultSeasons}
                            >
                            
                        </MultipleSelectCheckmarks>

                        <div className="m-2 d-flex flex-row border px-3 py-2 g-x-2 bg-light ">
                            <label className="form-label me-2 d-none">Select Location:</label>
                            {homeAwayArr.map((item) => (
                                <div key={item} className="form-check form-check-inline">
                                    <input
                                        style={formCheckStyle}
                                        className="form-check-input small-radio"
                                        type="radio"
                                        id={ item.toLowerCase() }
                                        name="location"                                        
                                        value={item}
                                        checked={homeAway === item}
                                        onChange={(e) => handleLocationChange(e, item)}
                                    />
                                    <label htmlFor={item.toLowerCase()}>{item}</label>
                                </div>
                            ))}
                        </div>
                </>
            )}
        </div>
    );
}

export default WLoptions;